export default "__VITE_ASSET__a639baca__"